import { Reducer } from 'redux'
import { DeliveryRatingActionTypes, DeliveryRatingState } from './types'

const initialState: DeliveryRatingState = {
  loading: true,
  isValid: false,
  isSent: false,
}

const reducer: Reducer<DeliveryRatingState> = (state = initialState, action) => {
  switch (action.type) {
    case DeliveryRatingActionTypes.RATING_CREATE_RESPONSE:
      return {
        ...state,
        loading: false,
        isSent: action.payload.isSent,
      }
    case DeliveryRatingActionTypes.RATING_VALIDATE_RESPONSE:
      return {
        ...state,
        isValid: action.payload.isValid,
        loading: false,
      }
    case DeliveryRatingActionTypes.RATING_CREATE:
      return {
        ...state,
        loading: true,
      }
    case DeliveryRatingActionTypes.RATING_VALIDATE_FAILED:
      return {
        ...state,
        loading: false,
        isValid: false,
      }
    default:
      return state
  }
}

export { reducer as DeliveryRatingReducer }
